import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const CoinDetailsStyles = makeStyles((theme: Theme) =>
  createStyles({
    edited: {
      color: "#9CA3A8",
      fontFamily: "Söhne",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "14px",
      alignSelf: "flex-end",
    },
    saving: {
      color: "#9CA3A8",
      fontFamily: "Söhne",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "14px",
    },
    text: {
      color: "#002035",
      fontFamily: "Roobert",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "19px",
    },
    layout: {
      borderRadius: "10px",
      background: theme.palette.secondary.contrastText,
      padding: "16px 20px",
      minHeight: "220px",
      position: "relative",
    },
    link: {
      color: "#cc0000",
    },
    fadeOut: {
      animation: "$fadeOut 2s forwards",
    },
    "@keyframes fadeOut": {
      from: {
        opacity: 1,
      },
      to: {
        opacity: 0,
      },
    },
  }),
);
